










































import { Component, Vue, Prop } from "@/shared/vuepack";
import * as SharedRoutes from "@/shared/route-names";
import { AuthType } from "@/shared/types";
import { useMfaStore } from "@/shared/store/mfa";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
  }
})
export default class AddMfa extends Vue {

  mfaStore = useMfaStore();
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  userStore = useUserStore();
  themeStore = useThemeStore();

  @Prop()
  settingsOverride: () => string;

  get linkRoute () {
    if (!this.settingsOverride) {
      return { name: SharedRoutes.Security };
    }

    const s = this.settingsOverride();
    return {
      name: s ? s : SharedRoutes.Security
    };
  }

  get show () {
    return this.custodianSettingsStore.allowMfa && this.mfaStore.showMfaModal;
  }

  get isOkta () {
    return this.userStore.authType === AuthType.Okta;
  }

  skip () {
    this.mfaStore.setShowMfa(false);
  }

  stop () {
    this.mfaStore.setMfaPreference(false);
  }

  onHidden (e) {
    this.skip();
  }
}
